import { createAsyncThunk } from "@reduxjs/toolkit";

import LocalStorage from "../../../../Services/Storage/LocalStorage";

import StorageModel from "../../../../Models/StorageModel";
import HttpsClient from "../../../../Services/HttpsClient";
import ApiHelper from "../../../../Services/ApiHelper";
import Cache from "../../../../Services/Cache";
import SadminDashAPI from "../API/SadminDashAPI";
import { SadminDashApiUrls } from "../API/SadminDashAPI";

const storage = new LocalStorage();
const storageModel = new StorageModel(storage);
const cache = new Cache(storageModel);

const httpsClient = new HttpsClient();
const apiHelper = new ApiHelper(httpsClient);
const sadminDashAPI = new SadminDashAPI(apiHelper, cache);

export const getSadminDashData = createAsyncThunk(
  SadminDashApiUrls.getSadminDashData,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    return await sadminDashAPI.getSadminDashData(payload, token);
  }
);
